import { Box } from '@coolblue-development/becky';
import { useTelephonyContext } from '../../../../../contexts/TelephonyContext';
import TelephonyTopPanel from './TelephonyTopPanel';

const TelephonyPage = (): JSX.Element => {
  const { selectedRecentCall } = useTelephonyContext();

  return (
    <Box>
      <TelephonyTopPanel selectedRecentCall={selectedRecentCall} />
    </Box>
  );
};

export default TelephonyPage;
